import MoreOutlinedIcon from '@ant-design/icons/MoreOutlined'

import Button from '@mui/material/Button'

import Section from '@components/Details/Section'
import TimelineNotes, { TimelineNoteCreation } from '@components/TimelineNotes'

import { useAssessmentNoteCreation, useAssessmentNotes } from '../AssessmentDetailsModal.hooks'

export default function NotesSection({ assessmentId, readOnly, onCreate }) {
  const create = useAssessmentNoteCreation(assessmentId, onCreate)
  const { data, isPending, fetchNextPage, hasNextPage, isFetchingNextPage } = useAssessmentNotes(assessmentId)

  const showLoading = isPending
  const showEmpty = !showLoading && data?.length === 0
  const showData = !showEmpty && data?.length > 0

  return (
    <Section mini title="Notes">
      {!readOnly && <TimelineNoteCreation draftKey={`assessment-${assessmentId}-note`} onSend={(message) => create.mutateAsync(message)} />}
      {showLoading && <TimelineNotes.Loading />}
      {showEmpty && <TimelineNotes.Empty readOnly={readOnly} />}
      {showData && (
        <TimelineNotes>
          {data.map((note, i) => {
            return <TimelineNotes.Item key={note.id} data={note} isLast={data.length - 1 === i} />
          })}
          {hasNextPage && (
            <Button
              fullWidth
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
              endIcon={<MoreOutlinedIcon rotate={90} />}
              loadingPosition="end"
              sx={{ textTransform: 'none' }}
            >
              more
            </Button>
          )}
        </TimelineNotes>
      )}
    </Section>
  )
}
